import React from "react";
import { NavLink } from "react-router-dom";
import { MenuItem } from "semantic-ui-react";

function DashboardLink({ to, content, ...rest }) {
	const activeLinkStyles = {
		borderLeft: "2px solid green",
		color: "green",
	};
	return (
		<MenuItem {...rest}>
			<NavLink
				activeStyle={activeLinkStyles}
				to={to}
				style={{
					color: "rgba(0,0,0,0.5)",
					borderLeft: "2px solid rgba(0,0,0,0)",
					paddingLeft: "5px",
					transition: "0.2s ease-out",
				}}
			>
				{content}
			</NavLink>
		</MenuItem>
	);
}

export default DashboardLink;
